module.exports = __webpack_public_path__ + "img/nav_logo.png";